import {
    RunnitNodeFieldDisplayWIDTH_HEIGHT,
    runnitValidateField,
    RunnitFieldValidationResult,
    extractInputMediaDimensions,
    TargetResolutionDimensions,
    RunnitNodeRunInputValue,
} from '@run-diffusion/shared';

export type ValidationResult = RunnitFieldValidationResult;

export function validateWidthHeightValue(
    display: RunnitNodeFieldDisplayWIDTH_HEIGHT | null | undefined,
    value: unknown,
): ValidationResult {
    return runnitValidateField(value, {
        __rfield: true,
        uuid: '',
        fieldDefUuid: '',
        type: 'WIDTH_HEIGHT',
        display: display ?? {},
    } as any);
}

// Size of the field named by display.dataFieldDefUuid. An IMGS value is a list,
// so it uses the first image in display order (uploads, then node run results).
export function dataSourceDimensions(value: RunnitNodeRunInputValue): TargetResolutionDimensions | null {
    if (value && typeof value === 'object' && ('uploads' in value || 'nodeRunResults' in value)) {
        if (value.uploads?.[0]) return extractInputMediaDimensions({ upload: value.uploads[0] });
        if (value.nodeRunResults?.[0]) return extractInputMediaDimensions({ nodeRunResult: value.nodeRunResults[0] });
        return null;
    }
    return extractInputMediaDimensions(value);
}
